export default function Eyebrow({ children }) {
  return (
    <span
      className="inline-flex items-center rounded-full px-3 py-1 text-[11px] font-semibold tracking-[0.1em] uppercase mb-5 block"
      style={{
        background: 'rgba(99,91,255,0.08)',
        border: '1px solid rgba(99,91,255,0.2)',
        color: '#635BFF',
        width: 'fit-content',
      }}
    >
      {children}
    </span>
  );
}
